import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { SpaceTabDocumentType } from 'api/space/space-tab';
import { TemplateObjectType, TemplatesAPI } from 'data/templates/api';
import { setupSpaceTabsOnSpaces } from 'data/templates/projects/slices';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import { createDocumentTemplateAction } from '../actions';
import { DocumentTemplateSourceType } from '../types';
function* createDocumentTemplateSaga(action) {
    const { payload: { spaceId, state, templateName, handleAlways, handleFailure, handleSuccess } } = action;
    try {
        const template = {
            templateId: 'new',
            templateName,
            templateContent: {
                documentId: floatUid(),
                title: templateName,
                sections: [
                    {
                        content: '<p></p>',
                        documentSectionId: floatUid(),
                        meta: {
                            sectionType: 'PUBLIC',
                            resourceSections: []
                        },
                        createdAt: +new Date()
                    }
                ]
            },
            objectType: TemplateObjectType.Document,
            state,
            sourceType: spaceId ? DocumentTemplateSourceType.SpaceTab : DocumentTemplateSourceType.Default
        };
        const documentTemplate = yield TemplatesAPI.save(template);
        if (spaceId) {
            yield put(setupSpaceTabsOnSpaces({
                spaceTab: {
                    spaceTabId: documentTemplate.templateId,
                    spaceTabTitle: documentTemplate.templateName || '',
                    spaceTabType: SpaceTabDocumentType.RocketlaneDocument,
                    url: `/templates/${documentTemplate.templateId}`
                },
                spaceId
            }));
        }
        if (handleSuccess) {
            handleSuccess(documentTemplate.templateId);
        }
    } catch (error) {
        logger.error('an error creating a document template', {
            error
        });
        message.error('There was an error creating a document template');
        if (handleFailure) {
            handleFailure();
        }
    }
    if (handleAlways) {
        handleAlways();
    }
}
export function* watchCreateDocumentTemplateSaga() {
    yield takeLatest(createDocumentTemplateAction.type, createDocumentTemplateSaga);
}
